/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import ouiStyle from '@goldwasserexchange/oui-style';
import * as React from 'react';
export var TableBodyRowContainer = function (props) {
    var innerRef = props.innerRef, display = props.display, borderStyle = props.borderStyle, borderHorizontalStyle = props.borderHorizontalStyle, borderVerticalStyle = props.borderVerticalStyle, borderTopStyle = props.borderTopStyle, borderLeftStyle = props.borderLeftStyle, borderBottomStyle = props.borderBottomStyle, borderRightStyle = props.borderRightStyle, borderWidth = props.borderWidth, borderHorizontalWidth = props.borderHorizontalWidth, borderVerticalWidth = props.borderVerticalWidth, borderTopWidth = props.borderTopWidth, borderLeftWidth = props.borderLeftWidth, borderBottomWidth = props.borderBottomWidth, borderRightWidth = props.borderRightWidth, borderColor = props.borderColor, borderHorizontalColor = props.borderHorizontalColor, borderVerticalColor = props.borderVerticalColor, borderTopColor = props.borderTopColor, borderLeftColor = props.borderLeftColor, borderBottomColor = props.borderBottomColor, borderRightColor = props.borderRightColor, parentBorderTopStyle = props.parentBorderTopStyle, parentBorderLeftStyle = props.parentBorderLeftStyle, parentBorderBottomStyle = props.parentBorderBottomStyle, parentBorderRightStyle = props.parentBorderRightStyle, parentBorderTopColor = props.parentBorderTopColor, parentBorderLeftColor = props.parentBorderLeftColor, parentBorderBottomColor = props.parentBorderBottomColor, parentBorderRightColor = props.parentBorderRightColor, parentBorderTopWidth = props.parentBorderTopWidth, parentBorderLeftWidth = props.parentBorderLeftWidth, parentBorderBottomWidth = props.parentBorderBottomWidth, parentBorderRightWidth = props.parentBorderRightWidth, borderRadius = props.borderRadius, borderLeftBeforeTopRadius = props.borderLeftBeforeTopRadius, borderRightBeforeTopRadius = props.borderRightBeforeTopRadius, borderLeftBeforeBottomRadius = props.borderLeftBeforeBottomRadius, borderRightBeforeBottomRadius = props.borderRightBeforeBottomRadius, borderTopRadius = props.borderTopRadius, borderRightRadius = props.borderRightRadius, borderBottomRadius = props.borderBottomRadius, borderLeftRadius = props.borderLeftRadius, borderTopLeftRadius = props.borderTopLeftRadius, borderTopRightRadius = props.borderTopRightRadius, borderBottomRightRadius = props.borderBottomRightRadius, borderBottomLeftRadius = props.borderBottomLeftRadius, borderSpacing = props.borderSpacing, borderCollapse = props.borderCollapse, onClick = props.onClick, cursor = props.cursor, padding = props.padding, paddingHorizontal = props.paddingHorizontal, paddingVertical = props.paddingVertical, paddingTop = props.paddingTop, paddingLeft = props.paddingLeft, paddingBottom = props.paddingBottom, paddingRight = props.paddingRight, iconContainer = props.iconContainer, baselinePadding = props.baselinePadding, childPaddingTop = props.childPaddingTop, childPaddingLeft = props.childPaddingLeft, childPaddingBottom = props.childPaddingBottom, childPaddingRight = props.childPaddingRight, margin = props.margin, marginHorizontal = props.marginHorizontal, marginVertical = props.marginVertical, marginTop = props.marginTop, marginRight = props.marginRight, marginBottom = props.marginBottom, marginLeft = props.marginLeft, clearfix = props.clearfix, backgroundColor = props.backgroundColor, children = props.children;
    var css = React.useMemo(function () { return ouiStyle.makeCss({
        display: display,
        backgroundColor: backgroundColor,
        borderStyle: borderStyle,
        borderHorizontalStyle: borderHorizontalStyle,
        borderVerticalStyle: borderVerticalStyle,
        borderTopStyle: borderTopStyle,
        borderLeftStyle: borderLeftStyle,
        borderBottomStyle: borderBottomStyle,
        borderRightStyle: borderRightStyle,
        borderWidth: borderWidth,
        borderHorizontalWidth: borderHorizontalWidth,
        borderVerticalWidth: borderVerticalWidth,
        borderTopWidth: borderTopWidth,
        borderLeftWidth: borderLeftWidth,
        borderBottomWidth: borderBottomWidth,
        borderRightWidth: borderRightWidth,
        borderColor: borderColor,
        borderHorizontalColor: borderHorizontalColor,
        borderVerticalColor: borderVerticalColor,
        borderTopColor: borderTopColor,
        borderLeftColor: borderLeftColor,
        borderBottomColor: borderBottomColor,
        borderRightColor: borderRightColor,
        parentBorderTopStyle: parentBorderTopStyle,
        parentBorderLeftStyle: parentBorderLeftStyle,
        parentBorderBottomStyle: parentBorderBottomStyle,
        parentBorderRightStyle: parentBorderRightStyle,
        parentBorderTopColor: parentBorderTopColor,
        parentBorderLeftColor: parentBorderLeftColor,
        parentBorderBottomColor: parentBorderBottomColor,
        parentBorderRightColor: parentBorderRightColor,
        parentBorderTopWidth: parentBorderTopWidth,
        parentBorderLeftWidth: parentBorderLeftWidth,
        parentBorderBottomWidth: parentBorderBottomWidth,
        parentBorderRightWidth: parentBorderRightWidth,
        borderRadius: borderRadius,
        borderLeftBeforeTopRadius: borderLeftBeforeTopRadius,
        borderRightBeforeTopRadius: borderRightBeforeTopRadius,
        borderLeftBeforeBottomRadius: borderLeftBeforeBottomRadius,
        borderRightBeforeBottomRadius: borderRightBeforeBottomRadius,
        borderTopRadius: borderTopRadius,
        borderRightRadius: borderRightRadius,
        borderBottomRadius: borderBottomRadius,
        borderLeftRadius: borderLeftRadius,
        borderTopLeftRadius: borderTopLeftRadius,
        borderTopRightRadius: borderTopRightRadius,
        borderBottomRightRadius: borderBottomRightRadius,
        borderBottomLeftRadius: borderBottomLeftRadius,
        borderSpacing: borderSpacing,
        borderCollapse: borderCollapse,
        cursor: cursor,
        padding: padding,
        paddingHorizontal: paddingHorizontal,
        paddingVertical: paddingVertical,
        paddingTop: paddingTop,
        paddingLeft: paddingLeft,
        paddingBottom: paddingBottom,
        paddingRight: paddingRight,
        iconContainer: iconContainer,
        baselinePadding: baselinePadding,
        childPaddingTop: childPaddingTop,
        childPaddingLeft: childPaddingLeft,
        childPaddingBottom: childPaddingBottom,
        childPaddingRight: childPaddingRight,
        margin: margin,
        marginHorizontal: marginHorizontal,
        marginVertical: marginVertical,
        marginTop: marginTop,
        marginRight: marginRight,
        marginBottom: marginBottom,
        marginLeft: marginLeft,
        clearfix: clearfix,
    }); }, [
        display,
        backgroundColor,
        borderStyle,
        borderHorizontalStyle,
        borderVerticalStyle,
        borderTopStyle,
        borderLeftStyle,
        borderBottomStyle,
        borderRightStyle,
        borderWidth,
        borderHorizontalWidth,
        borderVerticalWidth,
        borderTopWidth,
        borderLeftWidth,
        borderBottomWidth,
        borderRightWidth,
        borderColor,
        borderHorizontalColor,
        borderVerticalColor,
        borderTopColor,
        borderLeftColor,
        borderBottomColor,
        borderRightColor,
        parentBorderTopStyle,
        parentBorderLeftStyle,
        parentBorderBottomStyle,
        parentBorderRightStyle,
        parentBorderTopColor,
        parentBorderLeftColor,
        parentBorderBottomColor,
        parentBorderRightColor,
        parentBorderTopWidth,
        parentBorderLeftWidth,
        parentBorderBottomWidth,
        parentBorderRightWidth,
        borderRadius,
        borderLeftBeforeTopRadius,
        borderRightBeforeTopRadius,
        borderLeftBeforeBottomRadius,
        borderRightBeforeBottomRadius,
        borderTopRadius,
        borderRightRadius,
        borderBottomRadius,
        borderLeftRadius,
        borderTopLeftRadius,
        borderTopRightRadius,
        borderBottomRightRadius,
        borderBottomLeftRadius,
        borderSpacing,
        borderCollapse,
        cursor,
        padding,
        paddingHorizontal,
        paddingVertical,
        paddingTop,
        paddingLeft,
        paddingBottom,
        paddingRight,
        iconContainer,
        baselinePadding,
        childPaddingTop,
        childPaddingLeft,
        childPaddingBottom,
        childPaddingRight,
        margin,
        marginHorizontal,
        marginVertical,
        marginTop,
        marginRight,
        marginBottom,
        marginLeft,
        clearfix,
    ]);
    return (jsx("tr", { css: ouiStyle.mediaQuery(css), ref: innerRef, onClick: onClick }, children));
};
